import React from 'react'
import Button, {ButtonProps} from '@mui/material/Button'
import styled from 'styled-components'
import buttonStyles from './button.styles'

interface ApButtonProps extends ButtonProps {
  ap_type: 'primary' | 'secondary'
}
const apAtomName = {ap_atom_name: 'buttonAtom'}

const ButtonAtom = styled((props: ApButtonProps) => {
  return (
    <Button
      {...apAtomName}
      {...props}
      variant={props.ap_type === 'primary' ? 'contained' : 'outlined'}
    >
      {React.isValidElement(props.children) ? (
        props.children
      ) : (
        <span className="text-elipsis">{props.children}</span>
      )}
    </Button>
  )
})`
  ${buttonStyles}
`

export default ButtonAtom
